// TDM — Add-to-cart confirmation toast.
// Shows a brief, accessible confirmation when a product is successfully added
// to the cart. This complements (does not replace) the fly-to-cart animation
// and the button's "added" state, and is especially useful when the cart
// drawer is configured not to auto-open.
(function () {
  if (window.__tdmCartToastInit) return;
  window.__tdmCartToastInit = true;

  var HIDE_DELAY = 4000;
  /** @type {HTMLElement | null} */
  var toast = null;
  var hideTimeout = null;

  function cartUrl() {
    return window.Theme && Theme.routes && Theme.routes.cart_url ? Theme.routes.cart_url : '/cart';
  }

  function ensureToast() {
    if (toast && document.body.contains(toast)) return toast;

    toast = document.createElement('div');
    toast.className = 'tdm-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="tdm-cart-toast__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" ' +
        'stroke-linecap="round" stroke-linejoin="round"><path d="M4 10.5l3.5 3.5L16 6"/></svg>' +
      '</span>' +
      '<span class="tdm-cart-toast__text"></span>' +
      '<a class="tdm-cart-toast__link" href="' + cartUrl() + '">Voir le panier</a>' +
      '<button type="button" class="tdm-cart-toast__close" aria-label="Fermer">&times;</button>';

    document.body.appendChild(toast);

    var closeBtn = toast.querySelector('.tdm-cart-toast__close');
    if (closeBtn) closeBtn.addEventListener('click', hide);

    return toast;
  }

  function show(message) {
    var el = ensureToast();
    var text = el.querySelector('.tdm-cart-toast__text');
    if (text) text.textContent = message;

    // Force reflow so the entry transition runs even on consecutive adds.
    void el.offsetWidth;
    el.classList.add('is-visible');

    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(hide, HIDE_DELAY);
  }

  function hide() {
    clearTimeout(hideTimeout);
    if (toast) toast.classList.remove('is-visible');
  }

  document.addEventListener('cart:update', function (event) {
    var data = event && event.detail && event.detail.data;
    if (!data) return;

    // `CartAddEvent` and `CartUpdateEvent` share the `cart:update` name, so we
    // only react to genuine, successful adds — not quantity/line edits.
    if (data.source !== 'product-form-component' || data.didError) return;

    // When the drawer is set to auto-open, the opening drawer is the
    // confirmation; showing a toast that immediately hides would just flash.
    var drawer = document.querySelector('cart-drawer-component[auto-open]');
    if (drawer) return;

    show('Produit ajouté au panier');
  });

  // Avoid redundancy if the cart drawer opens (e.g. auto-open enabled).
  document.addEventListener('dialog:open', hide, true);
})();
